import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRGenerate from '../../../widgets/QRGenerate';


class CompanyQrCodeCard extends Component {
    constructor(props) {
        super()

        this.state = {
        }
    }

    render() {
        const { companyData,modalInfoTextStyle} = this.props;
        const { coid } = companyData;
        // const csscard = {
        //     display: "block",
        //     width: "30vw",
        //     height: "24vw"

        // }
        return (
            // <div className="card p-2" style={{borderRadius:'15px',overflow:'auto'}}>
            //     <div className="d-flex justify-content-center d-flex align-items-center card-body">
            //         <QRGenerate value={proid ?? ''}  />
            //     </div>
            // </div>

            <div className="card p-2" style={{ borderRadius: '15px', overflow: 'auto' }}>
                <div className="card-header bg-white p-0 mx-2 mb-2">
                    <div className="row">
                        <div className="col-12">
                            <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>Join this company</p>
                            <p style={modalInfoTextStyle}>Let your colleagues join this company by asking them to scan this QR code using AssetTag app.</p>
                        </div>
                    </div>
                </div>
                <div className="card-body ">
                    <QRGenerate value={coid ?? ''} />
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        snagDetail: state.firestore.data.Snag,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        project: state.project,
        userData: state.firebase.profile,
        alu: state.alu,
        companyData: state.firestore.data.Company,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
    }
}



export default connect(mapStateToProps)(CompanyQrCodeCard)